import { createI18n } from 'vue-i18n';
import { en } from './locales/en';
import { es } from './locales/es';
import { fr } from './locales/fr';

export type SupportedLocale = 'en' | 'es' | 'fr';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'es', 'fr'];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

const messages = {
  en,
  es,
  fr,
};

let globalI18n: ReturnType<typeof createI18n> | null = null;

export function createViewerI18n() {
  if (globalI18n) {
    return globalI18n;
  }

  globalI18n = createI18n({
    legacy: false,
    locale: DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    messages,
  });

  return globalI18n;
}

export function getGlobalI18n() {
  if (!globalI18n) {
    return createViewerI18n();
  }
  return globalI18n;
}

export function setLanguage(locale: SupportedLocale): void {
  const i18n = getGlobalI18n();
  (i18n.global.locale as { value: string }).value = locale;
}

/**
 * Helper function to get translations outside of Vue components
 * Use this in error handlers, utility functions, etc.
 * @param key - The translation key
 * @returns The translated string
 */
export function translate(key: string): string {
  const i18n = getGlobalI18n();
  return (i18n.global.t as (key: string) => string)(key);
}

export function getLanguage(): SupportedLocale {
  const i18n = getGlobalI18n();
  return (i18n.global.locale as { value: string }).value as SupportedLocale;
}
